document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        this.closePopup(e, () => { });
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      this.querySelector('.yg-popup-box-content-inner').innerHTML = $popupTemplate.innerHTML;
      document.querySelector('body').style.overflow = 'hidden';
      this.style.display = 'flex';
      fn();
    }
    closePopup(e, fn) {
      if (e.target.className == 'yg-popup-box-close' || e.target.className == 'yg-popup-box') {
        this.style.display = 'none';
        this.querySelector('.yg-popup-box-content-inner').innerHTML = '';
        document.querySelector('body').style.overflow = 'auto';
        fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.$popupBox = document.querySelector('yg-popup-box.yg-popup-box');
    }
    init() {
      // 这里放置初始化逻辑
      this.addEventListener('click', this.itemClick.bind(this));
    }
    itemClick() {
      // 这里放置自定义逻辑
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      $popupTemplate && this.$popupBox.openPopup($popupTemplate, () => { });

    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGDeferredMedia extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['playing'];
    }

    connectedCallback() {
      this.bindPosterButton();

      this.addEventListener('click', (e) => {
        const video = this.querySelector('video')
        if (
          video &&
          e.target === video &&
          !video.hasAttribute('controls')
        ) {
          e.preventDefault()
          e.stopPropagation()
          if (this.playing) {
            this.pause()
          } else {
            this.play()
          }
        }
      });

      if (this.autoplay) {
        this.inViewObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
            }
          });
        });
        this.inViewObserver.observe(this);
      }
    }

    get posterElement() {
      return this.querySelector('[id^="YG-DeferredPoster-"]');
    }

    get autoplay() {
      return this.hasAttribute('autoplay');
    }

    get playing() {
      return this.hasAttribute('playing');
    }

    get player() {
      return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.playerHandler(target, prop);
          };
        }
      });
    }

    bindPosterButton() {
      const poster = this.posterElement;
      if (poster && !poster.hasListener) {
        poster.addEventListener('click', this.onPosterClick.bind(this));
        poster.hasListener = true;
      }
    }

    async playerTarget() {
      const template = this.querySelector('template');
      if (!template) return Promise.resolve(null);

      if (!this.mediaElement) {
        const fragment = template.content.cloneNode(true);
        this.appendChild(fragment);
        this.mediaElement = this.querySelector('video, iframe');
      }

      this.bindPosterButton();
      return Promise.resolve(this.mediaElement);
    }

    playerHandler(target, prop) {
      if (!target) return;

      if (prop === 'play' && typeof target.play === 'function') {
        target.play();
        this.setAttribute('playing', '');
        this.removeAttribute('paused');
      }

      if (prop === 'pause' && typeof target.pause === 'function') {
        target.pause();
        this.removeAttribute('playing');
        this.setAttribute('paused', '');
      }
    }

    onPosterClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    }

    init() {
      if (!this.paused) {
        this.play();
      }
      return () => this.pause();
    }

    play() {
      if (!this.playing) {
        this.player.play();
      }
    }

    pause() {
      if (this.playing) {
        this.player.pause();
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'playing') {
        if (oldValue === null && newValue === '') {
          this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
          this.removeAttribute('paused');
        }
        if (newValue === null) {
          this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
          this.setAttribute('paused', '');
        }
      }
    }
  }

  class YGMedia extends YGDeferredMedia {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback(); // 保留父类逻辑

      if (!this.querySelector('img') && !this.hasAttribute('autoplay')) {
        this.inViewObserverNoAutoplay = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadMediaOnly();
              this.inViewObserverNoAutoplay.disconnect();
            }
          });
        });
        this.inViewObserverNoAutoplay.observe(this);
      }
    }

    async loadMediaOnly() {
      if (!this.mediaElement) {
        const template = this.querySelector('template');
        if (template) {
          const fragment = template.content.cloneNode(true);
          this.appendChild(fragment);
          this.mediaElement = this.querySelector('video, iframe');
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
          this.bindPosterButton();
        }
      }
    }

    async playerTarget() {
      if (this.hasAttribute('host')) {
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        return new Promise(async (resolve) => {
          const templateElement = this.querySelector('template');
          if (templateElement) {
            templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
          }
          this.bindPosterButton();

          const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('(max-width: 1023px)').matches;
          const host = this.getAttribute('host');

          if (host === 'youtube') {
            if (!window.YT || !window.YT.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.onload = res;
                document.head.appendChild(script);
              });
              await new Promise(res => {
                window.onYouTubeIframeAPIReady = res;
              });
            }

            const player = new YT.Player(this.querySelector('iframe'), {
              events: {
                onReady: () => {
                  if (muteVideo) player.mute();
                  resolve(player);
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PLAYING) {
                    this.setAttribute('playing', '');
                    this.removeAttribute('paused');
                  }
                  if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    this.removeAttribute('playing');
                    this.setAttribute('paused', '');
                  }
                }
              }
            });
          }

          if (host === 'vimeo') {
            if (!window.Vimeo || !window.Vimeo.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.onload = res;
                document.head.appendChild(script);
              });
            }

            const player = new Vimeo.Player(this.querySelector('iframe'));
            if (muteVideo) await player.setMuted(true);

            player.on('play', () => {
              this.setAttribute('playing', '');
              this.removeAttribute('paused');
            });
            player.on('pause', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });
            player.on('ended', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });

            resolve(player);
          }

          if (host === 'pimmedia') {
            // 假设 pimmedia 的 iframe 已经在页面上
            const iframe = this.querySelector('iframe');
            console.log("第三季我")
            if (!iframe) {
              console.warn('pimmedia iframe not found');
              return;
            }

            // 假设 mute 需要 postMessage 或类似接口，这里根据你具体接口改写
            if (muteVideo) {
              // 这里看你的 pimmedia 播放器怎么静音，比如 postMessage
              iframe.contentWindow.postMessage({ action: 'mute' }, '*');
            }

            // 监听 pimmedia 的消息事件（例如播放、暂停、结束）
            window.addEventListener('message', (event) => {
              // 确认是 pimmedia 的消息，可根据 event.origin 做验证
              const data = event.data;

              if (typeof data !== 'object' || !data.event) return;

              if (data.event === 'play') {
                this.setAttribute('playing', '');
                this.removeAttribute('paused');
              }
              if (data.event === 'pause' || data.event === 'ended') {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              }
            });

            // 返回一个模拟的 player 对象给 resolve
            resolve({
              play() {
                iframe.contentWindow.postMessage({ action: 'play' }, '*');
              },
              pause() {
                iframe.contentWindow.postMessage({ action: 'pause' }, '*');
              },
              mute() {
                iframe.contentWindow.postMessage({ action: 'mute' }, '*');
              }
            });
          }
        });
      } else {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        const player = this.querySelector('video');
        player.addEventListener('play', () => {
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
          this.removeAttribute('suspended');
        });
        player.addEventListener('pause', () => {
          if (!player.seeking && player.paused) {
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        });

        this.bindPosterButton();
        return player;
      }
    }

    playerHandler(target, prop) {
      const host = this.getAttribute('host');

      if (host === 'youtube') {
        if (prop === 'play') {
          target.playVideo();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pauseVideo();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else if (host === 'vimeo') {
        if (prop === 'play') {
          target.play();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else {
        if (prop === 'play') {
          target.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              this.setAttribute('suspended', '');
              target.controls = true;
              const replacementImageSrc = target.previousElementSibling?.currentSrc;
              if (replacementImageSrc) {
                target.poster = replacementImageSrc;
              }
            }
          });
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      }
    }
  }

  if (!customElements.get('yg-video')) {
    customElements.define('yg-video', YGMedia);
  }

  class YgSelect extends HTMLElement {
  constructor() {
    super();

    this.selectController = this.querySelector('.yg-select-controller');
    this.selectPlaceholder = this.querySelector('.yg-select-placeholder');
    this.selectOptionsWrapper = this.querySelector('.yg-select-options');
    this.defaultValue = this.getAttribute('default-value');
    this.selectedValue = null;

    this.flag = 0;
    this.position = 0;
    this.selectController.addEventListener('click', () => {
      this.toggleOptions();
    });

    const form = this.closest('.yg-parameter-value').querySelector('.shopify-product-form');
    form.addEventListener("variant:change", (e) => {
      const currentPrice = this.closest('.yg-parameter-value').querySelector('.yg-current-price');
      const comparePrice = this.closest('.yg-parameter-value').querySelector('.yg-original-price');
      if (e.detail.variant) {
        currentPrice.textContent = this.formatCurrencyWithoutCode(e.detail.variant.price / 100);
        if (e.detail.variant.compare_at_price > e.detail.variant.price) {
          comparePrice.textContent = this.formatCurrencyWithoutCode(e.detail.variant.compare_at_price / 100);
        }
      }
    });

    this.addEventListener('option-selected', (event) => {
      this.flag = 1;
      this.position = window.scrollY;
      this.selectedValue = event.detail.value;
      this.selectPlaceholder.textContent = event.detail.label;
      const forms = this.closest('.yg-variant-picker').querySelectorAll('.variant-picker fieldset.variant-picker__option');
      const options_text = this.selectedValue.split('/').map(item => item.trim());
      forms.forEach(form =>{
        const label_list = form.querySelectorAll('label');
        
        label_list.forEach(label => {
          options_text.forEach(text => {
            if (label.querySelector('span').innerText === text) {
              label.click();
              setTimeout(() => {
                this.flag = 0;
              }, 100);
            }
          })
        })
      })
      this.updateActiveOption(this.selectedValue);
      this.hideOptions();
    });

    window.addEventListener('scroll', (e) => {
      if (this.flag === 1) {
        e.preventDefault();
        e.stopPropagation();
        // 强制将滚动位置重置
        window.scrollTo({
          top: this.position, // 根据需要调整滚动位置
          behavior: 'auto'
        });
      }
      
    });

    // 点击其他地方关闭下拉框
    window.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.hideOptions();
      }
    });

    this.initializeDefault();
  }

  formatCurrencyWithoutCode(amount, locale = Shopify.locale, currency = Shopify.currency.active) {
    const parts = new Intl.NumberFormat(locale, { style: "currency", currency }).formatToParts(amount);
    let symbol = "", number = "";
    for (const part of parts) {
      if (part.type === "currency") symbol = part.value;
      if (part.type === "integer" || part.type === "decimal" || part.type === "fraction" || part.type === "group") number += part.value;
    }
    symbol = symbol.replace(/[A-Za-z]/g, "");
    return symbol + number;
  }
  initializeDefault() {
    const options = this.querySelectorAll('yg-option');
    options.forEach((option) => {
      if (option.getAttribute('value') === this.defaultValue) {
        this.selectedValue = this.defaultValue;
        this.selectPlaceholder.textContent = option.textContent;
        this.updateActiveOption(this.defaultValue);
      }
    });
  }

  updateActiveOption(value) {
    const options = this.querySelectorAll('yg-option');
    options.forEach((option) => {
      if (option.getAttribute('value') === value) {
        option.classList.add('yg-active');
      } else {
        option.classList.remove('yg-active');
      }
    });
  }

  toggleOptions() {
    if (this.selectOptionsWrapper.classList.contains('yg-show')) {
      this.hideOptions();
    } else {
      this.showOptions();
    }
  }

  showOptions() {
    this.selectOptionsWrapper.classList.add('yg-show');
  }

  hideOptions() {
    this.selectOptionsWrapper.classList.remove('yg-show');
  }

}

class YgOption extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => {
      this.selectOption();
    });
  }

  selectOption() {
    const event = new CustomEvent('option-selected', {
      detail: {
        value: this.getAttribute('value'),
        label: this.textContent,
      },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }
}

if (!window.customElements.get('yg-option')) {
  window.customElements.define('yg-option', YgOption);
}
if (!window.customElements.get('yg-select')) {
  window.customElements.define('yg-select', YgSelect);

}
})